import DocumentService from "../application/services/DocumentService";
import { Constants } from "./enum/Constants";

export class FilePropertiesValidation {
    private _validSize: boolean;
    private _validExtension: boolean;
    private _validFileName: boolean;
    private _maxSize: number;
    private _dragging: boolean;
    private _maximumFilesExceeded: boolean;
    private _fileEncrypted: boolean;
    private _isAPdfPortfolio: boolean;


    constructor() {
        this._validSize = true;
        this._validExtension = true;
        this._validFileName = true;
        this._maxSize = Constants.fileImporter.MAX_SIZE_FILE;  // 10MBytes
        this._dragging = false;
        this._maximumFilesExceeded = false;
        this._fileEncrypted = false;
        this._isAPdfPortfolio = false;
    }

    public get validSize() {
        return this._validSize;
    }

    public set validSize(validSize: boolean) {
        this._validSize = validSize;
    }

    public get validExtension() {
        return this._validExtension;
    }

    public set validExtension(validExtension: boolean) {
        this._validExtension = validExtension;
    }

    public get validFileName() {
        return this._validFileName;
    }

    public set validFileName(validFileName: boolean) {
        this._validFileName = validFileName;
    }

    public get maxSize() {
        return this._maxSize;
    }

    public set maxSize(maxSize: number) {
        this._maxSize = maxSize;
    }

    public get dragging() {
        return this._dragging;
    }

    public set dragging(dragging: boolean) {
        this._dragging = dragging;
    }

    public get maximumFilesExceeded() {
        return this._maximumFilesExceeded;
    }

    public set maximumFilesExceeded(maximumFilesExceeded: boolean) {
        this._maximumFilesExceeded = maximumFilesExceeded;
    }

    public get fileEncrypted() {
        return this._fileEncrypted;
    }

    public set fileEncrypted(fileEncrypted: boolean) {
        this._fileEncrypted = fileEncrypted;
    }

    public get isAPdfPortfolio() {
        return this._isAPdfPortfolio;
    }

    public set isAPdfPortfolio(isAPdfPortfolio: boolean) {
        this._isAPdfPortfolio = isAPdfPortfolio;
    }

    public isFileValid(file: any): boolean {
        this.validSize = this.validateFileSize(file);
        this.validExtension = this.validateFileExtension(file);
        this.validFileName = this.validateFileName(file);

        return this.validFileName && this.validSize && this.validExtension;
    }

    resetValidation() {
        this.validFileName = true;
        this.validExtension = true;
        this.validSize = true;
        this.maxSize = Constants.fileImporter.MAX_SIZE_FILE;
        this.isAPdfPortfolio = false;
        this.fileEncrypted = false;
    }

    public isFileAPdf(file: any): boolean {
        return file.extension.toLowerCase() === Constants.fileImporter.PDF_EXTENSION
    }

    private validateFileName(file: any): boolean {
        return !Constants.fileImporter.INVALID_FILE_NAME.some((validFormat: string) => file.fileName.includes(validFormat));
    }

    private validateFileExtension(file: any): boolean {
        return Constants.fileImporter.VALID_EXTENSIONS.includes(file.extension.toLowerCase());
    }

    private validateFileSize(file: any): boolean {
        return file.size <= this._maxSize;
    }
}
